module.exports = __webpack_public_path__ + "img/blog-56 (1).169cd757.jpg";